module.exports = __webpack_public_path__ + "static/theme-editor-layout-5c259ea0117d4ad8bbf1383362b282da.png";